import _ from 'lodash'
import { convertHelpers, createStaticViewFromDataCollections } from '../../common/convert'
import { createInitials } from '../../common/dataAdjust'
import { dataFix } from "../../common/dataFix"
import { ammendAllDates } from '../../common/dateFormatting'
import { createRefPath_client } from "../../firestoreData/appData/appRefPaths"
import { updateLinkHelpers } from '../../firestoreData/updates/subUpdates/fsUpdate_dataLInks'
import { dispatchConfirmationTypes, grts, responseHandlers, responseReducers } from "./reducerHelpers/dispatchProps"

const rts = {
  handleInit_noEventAccess: 'handleInit_noEventAccess',
  handleClear_appProfileData: 'handleClear_appProfileData',
  handleClear_regDataDocuments: 'handleClear_regDataDocuments',
  handleInit_eventInfo: 'handleInit_eventInfo',
  handleInit_regEventInfo: 'handleInit_regEventInfo',
  handleClear_googleSheetsData: 'handleClear_googleSheetsData',
  handleSet_appProfileData: 'handleSet_appProfileData',
  handleSet_appScheduledNotifications: 'handleSet_appScheduledNotifications',
  handleSet_appUserSnapshot: 'handleSet_appUserSnapshot',
  handleSet_appUserUrls: 'handleSet_appUserUrls',
  handleSet_eventCacheData: 'handleSet_eventCacheData',
  handleSet_eventData: 'handleSet_eventData',
  handleSet_eventInitData: 'handleSet_eventInitData',
  handleSet_eventStaticView: 'handleSet_eventStaticView',
  handleSet_eventStaticViews: 'handleSet_eventStaticViews',
  handleSet_googleSheetsStaticViews: 'handleSet_googleSheetsStaticViews',
  handleSet_googleSheetsData: 'handleSet_googleSheetsData',
  handleUpdate_eventStatus: 'handleUpdate_eventStatus',
  ...grts
}

const eventCreateTypes = {
  appDataDocuments: 'appDataDocuments',
  appDataLinks: 'appDataLinks',
  staticViews: 'staticViews',
}

export const eventInfoReducer = (state, action) => {

  const { eventCollectionsData, appDataDocuments, regDataDocuments, database_fns } = state
  const { type, dispatch, pathViews } = action

  const eventInfo_handlers = eventInfoHandlers(dispatch)
  // handleSet_appDataLinks
  const { handleSet_appGlobalData, handleSet_eventStaticViews } = eventInfo_handlers

  const _eventCollectionsData = eventCollectionsData ? _.cloneDeep(eventCollectionsData) : {}

  switch (type) {

    case rts.handleSet_eventCacheData:
      const { cache_eventInfo } = action
      const { appGlobalData } = cache_eventInfo ?? {}
      return { ...state, cache_eventInfo, appGlobalData }

    case rts.handleInit_noEventAccess:
      return { ...state, noEventAccess: true }

    case rts.handleInit_eventInfo:
      // eventInfo, notificationsInfo, appUsersInfo
      const { eventInfo } = action
      const { appDataDocuments: app_dd } = eventInfo
      if (!_.isEmpty(app_dd)) {
        const { _staticViews, _appDataLinks, _appDataDocs } = ammendAppDataDocs(app_dd, state.aps_viewItems)
        const _state = {
          ...state,
          ...action.eventInfo,
          appDataDocuments: _appDataDocs,
          regDataDocuments: null,
          staticViews: _staticViews,
          appDataLinks: _appDataLinks,
          staticViewKeys: _staticViews ? Object.keys(_staticViews) : [],
          eventDataSource: 'normal',
        }
        return _state
      }
      return { ...state, ...action.eventInfo }

    case rts.handleInit_regEventInfo:
      const { regEventInfo } = action
      const { regDataDocuments: reg_dd } = regEventInfo
      if (!_.isEmpty(reg_dd)) {
        const stt = {
          ...state,
          appDataDocuments: Object.freeze(reg_dd),
          regDataDocuments: reg_dd,
          eventDataSource: 'reg',
        }
        return stt
      }
      return state

    case rts.handleSet_eventData:
      return { ...state, eventData: action.eventData }

    case rts.handleSet_appUserSnapshot:
      return { ...state, appUserSnapshot: action.appUserSnapshot }

    case rts.handleSet_appScheduledNotifications:
      return { ...state, appScheduledNotifications: action.appScheduledNotifications }

    case rts.handleClear_regDataDocuments:
      return { ...state, regDataDocuments: null }

    case rts.handleSet_googleSheetsData:
      const { svs: _svs, _appDataLinks: _appDataLinksGs } = ammendAppDataLinks(action.googleSheetsData, state)
      return {
        ...state,
        googleSheetsData: action.googleSheetsData,
        googleSheetsPreview: action.googleSheetsPreview,
        appDataLinks: action.googleSheetsPreview?.appDataLinks,
        edf: 'googleSheets'
      }

    case rts.handleClear_googleSheetsData:
      return {
        ...state,
        googleSheetsData: null,
        googleSheetsPreview: null,
        appDataDocuments: null,
        appDataLinks: null,
        edf: 'none'
      }

    case rts.handleSet_eventInitData:

      const { data, cbProps } = action
      const { collectionName } = cbProps
      _eventCollectionsData[collectionName] = data
      const collectionKeys = Object.keys(_eventCollectionsData)

      const _linkedCollections = {}

      _.forEach(_eventCollectionsData, (cd, collectionItemKey) => {
        _linkedCollections[collectionItemKey] = {};
        _.forEach(cd, (cdi) => {
          _.forEach(_.pick(cdi, collectionKeys), (value, key) => {
            _linkedCollections[collectionItemKey][key] ||= value;
          });
        });
      });

      return {
        ...state,
        eventCollectionsData: _eventCollectionsData
      }

    case rts.handleClear_appProfileData:
      return { ...state, appProfileData: null }

    case rts.handleSet_appProfileData:

      const { d: _appUserProfileData } = action
      const { attendeeClientProfiles: _clientProfiles, attendees } = _appUserProfileData ?? {}

      if (state.pathViews.events) {

        if (_clientProfiles) {
          _appUserProfileData.eventProfiles = _.pickBy(_clientProfiles, profile => _.has(profile.events, state.pathViews.events))
        }

        if (attendees) {
          const attendeesByEmail = _.keyBy(attendees, 'email');

          const nonProfiledAttendees = _.pickBy(
            attendeesByEmail,
            (attendee, email) => {
              const profile = _clientProfiles?.[email]
              return !profile || !profile.initials || !profile.displayName
            }
          );

          const nonEventProfiles = _.pickBy(
            attendeesByEmail,
            (attendee, email) => {
              const profile = _appUserProfileData?.eventProfiles?.[email];
              return !_.get(profile, ['events', state?.pathViews?.events]);
            }
          );

          ammendNonProfiled(nonProfiledAttendees, state)
          ammendNonEvents(nonEventProfiles, state)

          _appUserProfileData.nonProfiledAttendees = nonProfiledAttendees
          _appUserProfileData.nonEventProfiles = nonEventProfiles
        }
      }
      return { ...state, appProfileData: _appUserProfileData }

    case rts.handleSet_eventStaticView:
      const svszz = state.staticViews ? _.cloneDeep(state.staticViews) : {}
      svszz[action.staticView] = action.staticViewData
      return { ...state, staticViews: svszz }

    case rts.handleSet_eventStaticViews:
      let { staticViews, pathViews: pathViews_results } = action.results ?? {}
      // if ((_.isEmpty(staticViews)) && appDataDocuments) {
      //   staticViews = createStaticViewFromDataCollections(appDataDocuments, state.aps_viewItems)
      // } 
      if (appDataDocuments) {
        staticViews = createStaticViewFromDataCollections(appDataDocuments, state.aps_viewItems)
      }
      return { ...state, staticEventKey: pathViews_results.events }
    // return { ...state, staticEventKey: pathViews_results.events, staticViews, staticViewKeys: staticViews ? Object.keys(staticViews) : [] }

    case rts.handleSet_appUserUrls:
      const { profileUrls, appUsersInfo } = action ?? {}
      const { clientProfiles } = appUsersInfo ?? {}
      return { ...state, appUserUrls: profileUrls, clientProfiles }

    case rts.handleSet_googleSheetsStaticViews:
      return { ...state, staticViews_gs: action.staticViews_gs }

    case rts.handleUpdate_eventStatus:
      const { events: eventKey } = pathViews
      const _eventData = _.cloneDeep(action.eventData)
      dataFix.ammendDeleteFields(_eventData)
      const _refPath = createRefPath_client(pathViews, ['events', eventKey])
      // database_fns.set_doc(_refPath, _eventData, true)
      return state

    // case rts.handleUpdate_appUserSnapshot:
    //   updateAppUserSnapshot(database_fns, pathViews, action.appUserAuthList, action.callback)
    //   return state

    // case rts.handleGet_appDataDocuments:
    //   getEventData(database_fns, state, action.selectedViewItemKey, action.callback)
    //   return state

    // case rts.handleCreate_appDataDocuments:
    //   createEventData(database_fns, state, eventCreateTypes.appDataDocuments, action.selectedViewItemKey, action.commit, action.callback)
    //   return state

    // case rts.handleCreate_appDataLinks:
    //   createEventData(database_fns, state, eventCreateTypes.appDataLinks, null, action.commit, action.callback)
    //   return state

    // case rts.handleCreate_staticViews:
    //   createEventData(database_fns, state, eventCreateTypes.staticViews, null, action.commit, action.callback)
    //   return state

    // case rts.handleCreate_appProfiles:
    //   createAppProfiles(state)
    //   return state

    case rts.handleStartUpdate:
    case rts.handleStopUpdate:
    case rts.handleCloseConfirmation:
    case rts.updateSuccess:
    case rts.updateSuccessAlt:
    case rts.updateError:
      return responseReducers(state, action, { dispatch, dispatchConfirmationType: dispatchConfirmationTypes.closeAfterConfirmation, questionProps: null })

    default:
      return state
  }
}

export const eventInfoInitialState = (initState) => {
  return { ...initState, appData: {}, eventCollectionsData: {}, missingSvDatas: {} }
};

export const eventInfoHandlers = (dispatch) => {
  return {
    handleInit_noEventAccess: () => { dispatch({ type: rts.handleInit_noEventAccess, dispatch }) },
    handleClear_appProfileData: () => { dispatch({ type: rts.handleClear_appProfileData, dispatch }) },
    handleClear_googleSheetsData: () => { dispatch({ type: rts.handleClear_googleSheetsData }) },
    handleClear_regDataDocuments: () => { dispatch({ type: rts.handleClear_regDataDocuments, dispatch }) },
    handleInit_eventInfo: (eventInfo) => { dispatch({ type: rts.handleInit_eventInfo, dispatch, eventInfo }) },
    handleInit_regEventInfo: (regEventInfo) => { dispatch({ type: rts.handleInit_regEventInfo, dispatch, regEventInfo }) },
    handleSet_appProfileData: (d) => { dispatch({ type: rts.handleSet_appProfileData, dispatch, d }) },
    handleSet_appScheduledNotifications: (appScheduledNotifications) => { dispatch({ type: rts.handleSet_appScheduledNotifications, dispatch, appScheduledNotifications }) },
    handleSet_appUserSnapshot: (appUserSnapshot) => { dispatch({ type: rts.handleSet_appUserSnapshot, dispatch, appUserSnapshot }) },
    handleSet_appUserUrls: (profileUrls, appUsersInfo) => { dispatch({ type: rts.handleSet_appUserUrls, dispatch, profileUrls, appUsersInfo }) },
    handleSet_eventCacheData: (pathViews, cache_eventInfo) => { dispatch({ type: rts.handleSet_eventCacheData, dispatch, pathViews, cache_eventInfo }) },
    handleSet_eventData: (eventData) => { dispatch({ type: rts.handleSet_eventData, dispatch, eventData }) },
    handleSet_eventInitData: (data, cbProps) => { dispatch({ type: rts.handleSet_eventInitData, dispatch, data, cbProps }) },
    handleSet_eventStaticView: (staticView, staticViewData) => { dispatch({ type: rts.handleSet_eventStaticView, dispatch, staticView, staticViewData }) },
    handleSet_eventStaticViews: (results) => { dispatch({ type: rts.handleSet_eventStaticViews, dispatch, results }) },
    handleSet_googleSheetsData: (googleSheetsData, googleSheetsPreview) => { dispatch({ type: rts.handleSet_googleSheetsData, dispatch, googleSheetsData, googleSheetsPreview }) },
    handleSet_googleSheetsStaticViews: (staticViews_gs) => { dispatch({ type: rts.handleSet_googleSheetsStaticViews, dispatch, staticViews_gs }) },
    handleUpdate_eventStatus: (eventData) => { dispatch({ type: rts.handleUpdate_eventStatus, dispatch, eventData }) },
    ...responseHandlers(dispatch)
  }
}

const ammendAppDataLinks = (appDd, aps_viewItems) => {

  const _updatedCollections = updateLinkHelpers.enforceBidirectionalLinks(appDd, false)

  const _appDataLinks = updateLinkHelpers.createAppLinks(null, appDd)
  delete appDd.staticViews
  const svs = createStaticViewFromDataCollections(appDd, aps_viewItems)
  ammendAllDates(appDd, false)
  return { svs, _appDataLinks }
}

const ammendAppDataDocs = (appDd, aps_viewItems) => {
  const _appDd = _.cloneDeep(appDd)
  if (_appDd && aps_viewItems) {
    const _viks = _.keys(aps_viewItems)
    _.forEach(_viks, viKey => {
      if (!_appDd[viKey]) {
        _appDd[viKey] = {}
      }
    })
  }
  const _appDataDocs = updateLinkHelpers.autoSyncBidirectional(_appDd)
  const { svs, _appDataLinks } = ammendAppDataLinks(_appDataDocs, aps_viewItems)
  const svsz = createStaticViewFromDataCollections(_appDataDocs, aps_viewItems)
  _.forEach(_appDataDocs, appDd => {
    convertHelpers.createItemKeys(appDd)
    dataFix.mutateTrueStrings(appDd)
  })
  return { _appDataDocs, _staticViews: svsz, _appDataLinks }
}

const ammendNonProfiled = (nonProfiledAttendees, state) => {
  _.forEach(nonProfiledAttendees, (npa) => {
    npa.id = npa.email
    npa.displayName = `${npa.firstName} ${npa.lastName}`
    npa.firstName = `${npa.firstName}`
    npa.lastName = `${npa.lastName}`
    npa.initials = createInitials(`${npa.firstName} ${npa.lastName}`)
    // npa.events = {
    //   [state.pathViews.events]: {
    //     eventKey: state.pathViews.events,
    //     appUserKey: npa._itemKey,
    //     name: state?.eventData?.name
    //   }
    // }
    delete npa.key
    delete npa._itemKey
  })
}

const ammendNonEvents = (nonEventProfiles, state) => {
  _.forEach(nonEventProfiles, (nep) => {
    if (!nep.events) { nep.events = {} }
    // nep.events[state.pathViews.events] = {
    //   eventKey: state.pathViews.events,
    //   appUserKey: nep._itemKey,
    //   name: state?.eventData?.name
    // }
    delete nep.key
    delete nep._itemKey
  })
}